import React from "react";
import { EconomicRevisions } from "../release-intelligence";
import { RateHistorySection } from "../rate-history";

export default function EconomicsHistoryScreen():JSX.Element{return <>
  <header className="economics-route-hero"><span>HISTORY</span><h1>Levels, movement, and revision.</h1><p>Compare rate paths and see where the first economic report differs from the latest available vintage.</p></header>
  <RateHistorySection/>
  <EconomicRevisions/>
</>}
